export default {
  en: {
    title: 'Order payment',
    scanQr: 'Scan the QR code to pay in rubles',
    openPaymentPage: 'Go to the bank',
    confirmPaid: 'I have paid',
    checkPayment: 'Check payment',
    paymentStillPending: 'Payment has not been received yet',
    waitingForConfirmation: 'Waiting for payment confirmation…',
    failed: 'Payment failed. Please try again.',
    qrAlt: 'Payment QR code',
    missingPayment: 'Payment data is unavailable',
    mvpRubOnlyHint: 'For now, payment is available in rubles via QR only.',
    payToCourier: 'Pay the courier on delivery',
    gotIt: 'Got it',
    successTitle: 'Thank you for your order',
    successBody: 'Your order has been placed',
    successToOrder: 'View order',
    successToHome: 'Home',
  },
  ru: {
    title: 'Оплата заказа',
    scanQr: 'Отсканируйте QR-код для оплаты в рублях',
    openPaymentPage: 'Перейти в банк',
    confirmPaid: 'Я оплатил',
    checkPayment: 'Проверить платеж',
    paymentStillPending: 'Платёж ещё не поступил',
    waitingForConfirmation: 'Ожидаем подтверждение оплаты…',
    failed: 'Оплата не прошла. Попробуйте снова.',
    qrAlt: 'QR-код для оплаты',
    missingPayment: 'Данные для оплаты недоступны',
    mvpRubOnlyHint: 'Сейчас доступна только оплата в рублях по QR-коду.',
    payToCourier: 'Оплата курьеру при получении',
    gotIt: 'Понятно',
    successTitle: 'Спасибо за заказ',
    successBody: 'Ваш заказ оформлен',
    successToOrder: 'К заказу',
    successToHome: 'На главную',
  },
}
